import { FC } from 'react';
import { WbDrawer, WbDrawerContent } from '@agilelab/plugin-wb-platform';
import { RoleForm, RoleFormProps, RoleFormType } from './RoleForm';

interface NewEditRoleDrawerProps extends RoleFormProps {
  defaultValues?: RoleFormType;
  id?: string;
  error?: Error;
  openDrawer: boolean;
  title?: string;
  submitLabel?: string;
}

export const NewEditRoleDrawer: FC<NewEditRoleDrawerProps> = ({
  onSubmit,
  dataState,
  openDrawer,
  setOpenDrawer,
  error,
  defaultValues,
  title,
  submitLabel,
  showCloneAssignments,
}) => {
  return (
    <WbDrawer
      open={openDrawer}
      setOpen={setOpenDrawer}
      size={50}
      title={title ?? (defaultValues ? 'Update Role' : 'New Role')}
    >
      <WbDrawerContent style={{ padding: 0 }}>
        <RoleForm
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          dataState={dataState}
          setOpenDrawer={setOpenDrawer}
          submitLabel={submitLabel}
          generalError={error}
          showCloneAssignments={showCloneAssignments}
        />
      </WbDrawerContent>
    </WbDrawer>
  );
};
